import {
  companyCodeColumnDefinition,
  countryTaxTypeColumnDefinition,
  connectionNameColumnDefinition,
  // currentPeriodCalcStatusColumnDefinition,
  // previousPeriodCalcStatusColumnDefinition,
  diagnosticsReportColumnDefinition,
  diagnosticsSeverityColumnDefinition,
  leColumnDefinition,
  tbeCompanyCodeColumnDefinition,
  tbeLeColumnDefinition,
  fromCurrencyColumnDefinition,
  toCurrencyColumnDefinition,
  fromCurrPrecColumnDefinition,
  toCurrPrecColumnDefinition,
  legalEntityColumnDefinition,
  businessUnitColumnDefinition,
  legalEntityDescriptionColumnDefinition,
  usTaxTypeColumnDefinition,
  currentPeriodCalcStatusColumnDefinition,
  previousPeriodCalcStatusColumnDefinition,
  ccDescriptionColumnDefinition,
  tbeCcDescriptionColumnDefinition,
  connNameColumnDefinition,
  tbeConnNameColumnDefinition,
  // esTaxTypeColumnDefinition,
} from '../../shared/columnDefinitions';

import LinkCellRenderer from '../../shared/cellRenderers/linkCellRenderer.component';

import { PillTypes } from './constants';
import { linkCellRendererFactory } from './linkCellRenderer.component';
import routes from '../../routes';

export const DiagnosticsColumnDefinitions = {
  taxBookingEntitiesColumnDefinitions: [
    diagnosticsSeverityColumnDefinition,
    diagnosticsReportColumnDefinition,
    {
      ...companyCodeColumnDefinition,
      cellRenderer: linkCellRendererFactory(
        value => `${routes.administration.TAX_BOOKING_ENTITIES}?companyCode=${value}`
      ),
    },
    ccDescriptionColumnDefinition,
    leColumnDefinition,
    {
      ...tbeCompanyCodeColumnDefinition,
      cellRenderer: linkCellRendererFactory(
        value => `${routes.administration.TAX_BOOKING_ENTITIES}?tbeCompanyCode=${value}`
      ),
    },
    tbeCcDescriptionColumnDefinition,
    tbeLeColumnDefinition,
    currentPeriodCalcStatusColumnDefinition,
    previousPeriodCalcStatusColumnDefinition,
    connNameColumnDefinition,
    tbeConnNameColumnDefinition,
  ],
  currenciesColumnDefinitions: [
    diagnosticsSeverityColumnDefinition,
    diagnosticsReportColumnDefinition,
    {
      ...fromCurrencyColumnDefinition,
      cellRenderer: linkCellRendererFactory(
        value => `${routes.administration.CURRENCY_CONVERSION_RATES}?fromCurrency=${value}`
      ),
    },
    {
      ...toCurrencyColumnDefinition,
      cellRenderer: linkCellRendererFactory(
        value => `${routes.administration.CURRENCY_CONVERSION_RATES}?toCurrency=${value}`
      ),
    },
    fromCurrPrecColumnDefinition,
    toCurrPrecColumnDefinition,
  ],
  obligationsColumnDefinitions: [
    diagnosticsSeverityColumnDefinition,
    diagnosticsReportColumnDefinition,
    {
      ...companyCodeColumnDefinition,
      cellRenderer: linkCellRendererFactory(
        value => `${routes.administration.OBLIGATIONS}?companyCode=${value}`
      ),
    },
    ccDescriptionColumnDefinition,
    countryTaxTypeColumnDefinition,
    connectionNameColumnDefinition,
    currentPeriodCalcStatusColumnDefinition,
    previousPeriodCalcStatusColumnDefinition,
  ],
  companyCodesColumnDefinitions: [
    diagnosticsSeverityColumnDefinition,
    diagnosticsReportColumnDefinition,
    {
      ...companyCodeColumnDefinition,
      cellRenderer: linkCellRendererFactory(
        value => `${routes.administration.COMPANY_CODES}?companyCode=${value}`
      ),
    },
    ccDescriptionColumnDefinition,
    {
      ...legalEntityColumnDefinition,
      cellRenderer: linkCellRendererFactory(
        value => `${routes.administration.LEGAL_ENTITY_SETTINGS}?legalEntity=${value}`
      ),
    },
    businessUnitColumnDefinition,
    connectionNameColumnDefinition,
    currentPeriodCalcStatusColumnDefinition,
    previousPeriodCalcStatusColumnDefinition,
  ],
  legalEntityColumnDefinitions: [
    diagnosticsSeverityColumnDefinition,
    diagnosticsReportColumnDefinition,
    {
      ...legalEntityColumnDefinition,
      cellRenderer: linkCellRendererFactory(
        value => `${routes.administration.LEGAL_ENTITY_SETTINGS}?legalEntity=${value}`
      ),
    },
    legalEntityDescriptionColumnDefinition,
    usTaxTypeColumnDefinition,
    // esTaxTypeColumnDefinition,
  ],
  provisionColumnDefinitions: [
    diagnosticsSeverityColumnDefinition,
    diagnosticsReportColumnDefinition,
    {
      ...companyCodeColumnDefinition,
      cellRenderer: LinkCellRenderer,
    },
    ccDescriptionColumnDefinition,
    currentPeriodCalcStatusColumnDefinition,
    previousPeriodCalcStatusColumnDefinition,
  ],
};

export const getColumnDefinitions = () => ({
  [PillTypes.TAX_BOOKING_ENTITIES]: DiagnosticsColumnDefinitions.taxBookingEntitiesColumnDefinitions,
  [PillTypes.CURRENCIES]: DiagnosticsColumnDefinitions.currenciesColumnDefinitions,
  [PillTypes.OBLIGATION]: DiagnosticsColumnDefinitions.obligationsColumnDefinitions,
  [PillTypes.COMPANY_CODE]: DiagnosticsColumnDefinitions.companyCodesColumnDefinitions,
  [PillTypes.LEGAL_ENTITY]: DiagnosticsColumnDefinitions.legalEntityColumnDefinitions,
  [PillTypes.PROVISION]: DiagnosticsColumnDefinitions.provisionColumnDefinitions,
});
